import { render, staticRenderFns } from "./documents.valueAddedTaxPP36.vue?vue&type=template&id=8cecd520&scoped=true"
import script from "./documents.valueAddedTaxPP36.vue?vue&type=script&lang=js"
export * from "./documents.valueAddedTaxPP36.vue?vue&type=script&lang=js"
import style0 from "./documents.valueAddedTaxPP36.vue?vue&type=style&index=0&id=8cecd520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cecd520",
  null
  
)

export default component.exports